<!-- 收款台选择弹窗组件 -->
<template>
  <el-dialog 
    title="选择收款台" 
    :visible.sync="dialogVisible" 
    width="500px" 
    append-to-body
    @close="onDialogClose" 
    @opened="onDialogOpened"
  >
    <el-table 
      ref="deskTable" 
      :data="deskList" 
      border 
      height="320px" 
      highlight-current-row
      :row-class-name="getDeskRowClassName" 
      @keydown.native="handleKeydown"
      @row-dblclick="onRowDoubleClick" 
      tabindex="0" 
      @row-click="onRowClick"
    >
      <el-table-column prop="deskCode" label="收款台编号" min-width="120" />
      <el-table-column prop="deskType" label="收款台类型" min-width="160" />
      <el-table-column prop="isSmall" label="是否允许抹零" min-width="160">
        <template slot-scope="scope">
          <el-tag>{{ scope.row.isSmall === 1 ? '是' : '否' }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="confirmSelect">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'DeskSelectDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    deskList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      selectedDeskIndex: -1, // 当前选中的收款台索引
      deskSelected: false
    }
  },
  computed: {
    dialogVisible: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    }
  },
  methods: {
    // 弹窗打开事件
    onDialogOpened() {
      console.log('收款台弹窗打开，收款台列表:', this.deskList)
      this.selectedDeskIndex = 0 // 默认选中第一个收款台
      console.log('设置初始选中索引为:', this.selectedDeskIndex)

      this.$nextTick(() => {
        // 聚焦到表格
        if (this.$refs.deskTable) {
          this.$refs.deskTable.$el.focus()
          console.log('表格聚焦成功')

          // 设置Element UI的当前行高亮
          if (this.deskList.length > 0) {
            this.$refs.deskTable.setCurrentRow(this.deskList[0])
          }
        } else {
          console.log('表格引用不存在')
        }
        // 滚动到选中的收款台
        this.scrollToSelectedDesk()
      })
    },

    // 弹窗关闭事件
    onDialogClose() {
      if (!this.deskSelected) {
        this.$emit('cancel')
      }
      // 清除选中状态
      this.selectedDeskIndex = -1
      if (this.$refs.deskTable) {
        this.$refs.deskTable.setCurrentRow(null)
      }
      this.deskSelected = false // 重置
    },

    // 处理键盘事件
    handleKeydown(event) {
      if (!this.dialogVisible) return
      if (this.deskList.length === 0) return

      // 先清除Element UI的当前行高亮
      if (this.$refs.deskTable) {
        this.$refs.deskTable.setCurrentRow(null)
      }

      if (event.key === 'ArrowUp') {
        event.preventDefault()
        event.stopPropagation()
        if (this.selectedDeskIndex > 0) {
          this.selectedDeskIndex--
        } else {
          this.selectedDeskIndex = this.deskList.length - 1
        }

        // 滚动到选中的收款台
        this.$nextTick(() => {
          this.scrollToSelectedDesk()
          // 设置Element UI的当前行高亮
          if (this.$refs.deskTable && this.selectedDeskIndex >= 0) {
            this.$refs.deskTable.setCurrentRow(this.deskList[this.selectedDeskIndex])
          }
        })
      } else if (event.key === 'ArrowDown') {
        event.preventDefault()
        event.stopPropagation()
        if (this.selectedDeskIndex < this.deskList.length - 1) {
          this.selectedDeskIndex++
        } else {
          this.selectedDeskIndex = 0
        }

        // 滚动到选中的收款台
        this.$nextTick(() => {
          this.scrollToSelectedDesk()
          // 设置Element UI的当前行高亮
          if (this.$refs.deskTable && this.selectedDeskIndex >= 0) {
            this.$refs.deskTable.setCurrentRow(this.deskList[this.selectedDeskIndex])
          }
        })
      } else if (event.key === 'Enter') {
        event.preventDefault()
        event.stopPropagation()
        this.confirmSelect()
      } else if (event.key === 'Escape') {
        event.preventDefault()
        event.stopPropagation()
        this.selectedDeskIndex = -1
        this.dialogVisible = false
        this.onDialogClose()
      }
    },

    // 确认选择收款台
    confirmSelect() {
      if (this.selectedDeskIndex >= 0 && this.selectedDeskIndex < this.deskList.length) {
        const selectedDesk = this.deskList[this.selectedDeskIndex]
        this.deskSelected = true // 标记为已选择
        this.dialogVisible = false
        this.$emit('confirm', selectedDesk)
      }
    },

    // 滚动到选中的收款台
    scrollToSelectedDesk() {
      this.$nextTick(() => {
        // 查找收款台选择弹窗中的表格
        const deskTable = document.querySelector('.el-dialog__wrapper:not([style*="display: none"]) .el-table')
        if (!deskTable) return
        const tableBody = deskTable.querySelector('.el-table__body-wrapper')
        if (tableBody && this.selectedDeskIndex >= 0) {
          const rows = tableBody.querySelectorAll('.el-table__row')
          if (rows[this.selectedDeskIndex]) {
            // 计算目标行的位置
            const targetRow = rows[this.selectedDeskIndex]
            const containerHeight = tableBody.clientHeight
            const rowTop = targetRow.offsetTop
            const rowHeight = targetRow.offsetHeight
            // 计算滚动位置，确保选中行在可视区域中间
            const scrollTop = rowTop - (containerHeight / 2) + (rowHeight / 2)
            tableBody.scrollTo({
              top: Math.max(0, scrollTop),
              behavior: 'smooth'
            })
          }
        }
      })
    },

    // 处理行点击事件
    onRowDoubleClick(row) {
      // 找到点击的收款台在列表中的索引
      const index = this.deskList.findIndex(item => item === row)
      if (index !== -1) {
        this.selectedDeskIndex = index
        // 设置Element UI的当前行高亮
        if (this.$refs.deskTable) {
          this.$refs.deskTable.setCurrentRow(row)
        }
        this.confirmSelect()
      }
    },

    onRowClick(row) {
      // 找到点击的收款台在列表中的索引
      const index = this.deskList.findIndex(item => item === row)
      if (index !== -1) {
        this.selectedDeskIndex = index
        // 设置Element UI的当前行高亮
        if (this.$refs.deskTable) {
          this.$refs.deskTable.setCurrentRow(row)
        }
        // 滚动到选中的收款台
        this.$nextTick(() => {
          this.scrollToSelectedDesk()
        })
      }
    },

    // 获取收款台行的class名称
    getDeskRowClassName({ row, rowIndex }) {
      return rowIndex === this.selectedDeskIndex ? 'selected-desk-row' : ''
    }
  }
}
</script>

<style scoped>
/* 收款台选择弹窗中选中行的样式 */
:deep(.selected-desk-row) {
  background-color: #ffdb12 !important;
}
:deep(.selected-desk-row td) {
  background-color: #ffdb12 !important;
}
/* 确保收款台选择弹窗中Element UI的当前行高亮样式不会被覆盖 */
:deep(.el-table__row.current-row td) {
  background-color: #ffdb12 !important;
}
</style>
